import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormControlLabel,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import {
  createStudentsAPIEndpoint,
  EndPoints,
} from "../../../../services/StudentAPIs";

export default function ExportQrCodesDialog({ open, onClose, students }) {
  const [selectedStudents, setSelectedStudents] = useState([]);

  const handleToggle = (id) => {
    setSelectedStudents((prev) =>
      prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id],
    );
  };

  const handleSelectAll = () => {
    if (selectedStudents.length === students.length) {
      setSelectedStudents([]); // unselect all
    } else {
      setSelectedStudents(students.map((s) => s.id)); // select all
    }
  };

  const handleExport = async () => {
    if (selectedStudents.length === 0) return;

    createStudentsAPIEndpoint(EndPoints.exportQrCodes)
      .fetch({
        params: { ids: selectedStudents },
        paramsSerializer: (params) =>
          params.ids.map((id) => `ids=${id}`).join("&"),
        responseType: "blob",

      })
      .then((res) => {
        const blob = new Blob([res.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute("download", "qrcodes.pdf");
        document.body.appendChild(link);
        link.click();
        link.remove();
        document.body.revokeObjectURL(link.href);

        onClose();
      })
      .catch((err) => {
        console.error("Failed to export QR codes:", err);
      });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth className="export-qr-dialog">
      <DialogTitle className="export-qr-dialog-title">Export QR Codes</DialogTitle>
      <DialogContent dividers>
        <FormControlLabel
          control={
            <Checkbox
              checked={selectedStudents.length === students.length}
              indeterminate={
                selectedStudents.length > 0 &&
                selectedStudents.length < students.length
              }
              onChange={handleSelectAll}
              className="select-all-checkbox"
            />
          }
          label="Select All"
        />
        <List className="student-list"
        >
          {students.map((student) => (
            <ListItem
              key={student.id}
              dense
              button
              onClick={() => handleToggle(student.id)}
              className="student-list-item"
            >
              <Checkbox
                checked={selectedStudents.includes(student.id)}
                tabIndex={-1}
                disableRipple
                className="student-checkbox"
              />
              <ListItemText
                primary={student.fullName}
                secondary={`Stage: ${student.educationStage} | Center: ${student.centerName}`}
                className="student-list-text"
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleExport}
          variant="contained"
          color="primary"
          disabled={selectedStudents.length === 0}
        >
          Export
        </Button>
      </DialogActions>
    </Dialog>
  );
}
